import { create } from "zustand";
import { ConsultantSidebarProps } from "../components/Shared/Sidebar/ConsultantsSidebar";
import { AssignedConsultantsSidebarProps } from "../components/Shared/Sidebar/AssignedConsultantsSidebar";

export type SidebarType = "MATCHING_CONSULTANTS" | "ASSIGNED_CONSULTANTS";

interface SidebarStore {
	/**
	 * The type of sidebar that is currently active, if any.
	 */
	activeSidebar?: SidebarType;
	sidebarProps?: any;
	openSidebar: (
		type: SidebarType,
		props: ConsultantSidebarProps | AssignedConsultantsSidebarProps
	) => any;
	closeSidebar: () => any;
}

export const useSidebarStore = create<SidebarStore>((set) => ({
	activeSidebar: undefined,
	openSidebar: (type, props) =>
		set((state) => ({
			...state,
			sidebarProps: props,
			activeSidebar: type,
		})),

	closeSidebar: () =>
		set((state) => ({
			...state,
			activeSidebar: undefined,
			sidebarProps: undefined,
		})),
}));
